import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Route } from 'next';
import useAuth from '@/context/auth/useAuth';

export default function useIsRestricted(isRestricted: boolean = false, to?: Route) {
    const router = useRouter();
    const { isAppInitialized } = useAuth();

    useEffect(() => {
        setTimeout(() => {
            if (isRestricted && isAppInitialized) router.replace(to || '/login');
        }, 0);
    }, [isRestricted, isAppInitialized]);

    return null;
}
